import SectionHub from '@/components/docs/SectionHub';

export default function Docs04MacrosAndSignalsCreditRatingsHub() {
  return <SectionHub sectionPath="04-macros-and-signals/credit-ratings" />;
}
